// extracted by mini-css-extract-plugin
export default {"Button":"TypeButton_Button__hk3WE"};